import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "text-base text-center"
};
const _hoisted_2 = {
  class: "flex-center"
};
import GridItem from "@/modules/club-grounds/components/GridItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'UnlockedSlot',
  props: {
    groundSlot: null,
    team: null
  },
  emits: ['update'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createBlock(GridItem, {
        color: _ctx.ColorEnum.Teal
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.LockOpen24Regular,
          size: "3rem",
          class: "mb-1"
        }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.IosTimer,
          class: "mr-1"
        }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.$date(__props.groundSlot.availableAt)), 1)])])]),
        _: 1
      }, 8, ["color"]);
    };
  }
});